import React, { useEffect, useState } from "react";
import api from "../lib/api";

export default function About() {
  const [data, setData] = useState({ description: "", gallery: [], stats: [] });
  useEffect(() => {
    api.get("/about").then((r) => setData({
      description: r.data.description || "",
      gallery: r.data.gallery || [],
      stats: r.data.stats || [],
    }));
  }, []);

  return (
    <div data-testid="about-page" className="bg-[#2A2A2A] min-h-screen">
      <header className="bg-[#1F1F1F] border-b border-[#3a3a3a] py-20">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10">
          <div className="kicker mb-5">O nas</div>
          <h1 className="font-display text-white text-3xl sm:text-5xl md:text-7xl uppercase leading-[0.9] break-words hyphens-auto">
            Pracownia,<br/><span className="text-[#FFCC00]">społeczność, idea</span>
          </h1>
        </div>
      </header>

      <section className="py-16 md:py-24">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <div className="kicker mb-4">Kim jesteśmy</div>
            <p className="text-white/80 text-lg leading-relaxed">{data.description}</p>

            {data.stats.length > 0 && (
              <div className="mt-10 grid grid-cols-2 gap-3" data-testid="about-stats">
                {data.stats.map((s, i) => (
                  <div key={i} className="border-l-2 border-[#FFCC00] pl-4 py-2" data-testid={`about-stat-${i}`}>
                    <div className="font-display text-3xl md:text-4xl text-white">{s.value}</div>
                    <div className="font-mono-acc text-[10px] text-white/55 uppercase mt-1">{s.label}</div>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="lg:col-span-7">
            <div className="gallery-grid" data-testid="about-gallery">
              {(data.gallery || []).map((src, i) => (
                <a
                  key={i}
                  href={src}
                  target="_blank"
                  rel="noreferrer"
                  className="gallery-item group block"
                  data-testid={`about-photo-${i}`}
                >
                  <img src={src} alt={`Maker space ${i + 1}`} loading="lazy"/>
                  <span className="badge">#{String(i + 1).padStart(2, "0")} / Maker Space</span>
                </a>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
